import { ref } from 'vue'
import { useConfigStore } from '../stores/useConfig'

export function useBlob() {
  const { apiConfig } = useConfigStore()
  const error = ref<Error | undefined>()
  const blobSource = ref<string>()
  const abortController = ref<AbortController>()

  function abortOngoing() {
    if (abortController.value) {
      abortController.value.abort()
      abortController.value = undefined
    }
  }

  async function loadBlob(source: string) {
    blobSource.value = undefined
    error.value = undefined
    try {
      const controller = new AbortController()
      abortOngoing()
      abortController.value = controller

      const response = await fetch(source, {
        signal: controller.signal,
        headers: {
          Authorization: apiConfig.token
        }
      })

      abortController.value = undefined
      const blob = await response.blob()
      blobSource.value = URL.createObjectURL(blob)
    } catch (e) {
      error.value = e
    }
  }

  return { blobSource, loadBlob, abortOngoing, error }
}
